import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiGlobe, FiLinkedin, FiMail, FiMapPin, FiPhone } from 'react-icons/fi';
import WaveDivider from '../components/WaveDivider';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: 'easeOut' }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4 }
    }
  };

  const companyLinks = [
    { path: '/about', label: 'About us' },
    { path: '/services', label: 'Services' },
    { path: '/case-studies', label: 'Case Studies' },
    { path: '/careers', label: 'Careers' },
    { path: '/insight', label: 'Insights' },
    { path: '/contact', label: 'Contact Us' }
  ];

  return (
    <motion.footer
      className="site-footer"
      variants={footerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <WaveDivider className="is-flip" />
      <div className="site-footer-grid" aria-hidden="true" />

      <div className="container py-5" style={{ maxWidth: '1320px' }}>
        <motion.div
          className="row g-4 g-lg-5"
          variants={staggerContainer}
        >
          <motion.div className="col-lg-5 col-md-12" variants={itemVariants}>
            <div className="site-footer-brand">
              <Link to="/" className="site-footer-logo-link">
                <span className="site-footer-name">
                  Coltigent Technology Services Pvt Ltd
                </span>
              </Link>
              <p className="site-footer-tagline">
                Your AI Product Engineering Partner. We help founders, CTOs, and growing businesses design, build, and scale AI-powered software products.
              </p>
              <a
                href="https://www.linkedin.com/company/coltigent-technology-services-pvt-ltd/"
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer-social"
                aria-label="Coltigent on LinkedIn"
              >
                <FiLinkedin />
              </a>
            </div>
          </motion.div>

          <motion.div className="col-lg-3 col-md-6" variants={itemVariants}>
            <h6 className="site-footer-heading">Company</h6>
            <ul className="site-footer-links">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div className="col-lg-4 col-md-6" variants={itemVariants}>
            <h6 className="site-footer-heading">Contact</h6>
            <div className="site-footer-contact">
              <div className="site-footer-contact-row">
                <span className="site-footer-icon">
                  <FiMapPin />
                </span>
                <span>
                  8th Floor, Office No. 818, Brahma Sky Uzuri – Opposite to PCMC Corporation Building, Pimpri, Pune, Maharashtra – 411018
                </span>
              </div>
              <a href="mailto:info@coltigent.com" className="site-footer-contact-row">
                <span className="site-footer-icon">
                  <FiMail />
                </span>
                <span>info@coltigent.com</span>
              </a>
              <a
                href="https://www.coltigent.com"
                className="site-footer-contact-row"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="site-footer-icon">
                  <FiGlobe />
                </span>
                <span>www.coltigent.com</span>
              </a>
              <a href="tel:+918540062205" className="site-footer-contact-row">
                <span className="site-footer-icon">
                  <FiPhone />
                </span>
                <span>+91- 8540062205</span>
              </a>
            </div>
          </motion.div>
        </motion.div>

        <div className="site-footer-divider" />
        <motion.div variants={itemVariants}>
          <div className="site-footer-bottom">
            <div className="site-footer-copy">
              © {currentYear} Coltigent Technology Services Pvt Ltd
            </div>
            <div className="site-footer-legal">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms-of-use">Terms of Use</Link>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;
